import { BackToTop, Footer, HeadingBox, Nav, TitleBox } from '../../components'
import { managedItSolution } from '../../utils/constants'
const ManagedSolution = () => {
  let even = []
  even = ['202','204','206','208','210']
  const numb = even.map((item) => item)
  const classes = "lg:px-10 px-4 py-12 flex lg:flex-row flex-col gap-5 justify-between"
  const evenClass = "lg:px-10 px-4 py-12 bg-[#37006718] flex lg:flex-row-reverse flex-col gap-5 justify-between"
  return (
    <>
    <Nav />
    <main>
        <section className="lg:py-20 py-12 lg:px-10 px-4 bg-[#FFE6D2] flex lg:flex-row flex-col  justify-between">
        <div>
          <HeadingBox
              title="Managed IT Solution"
              subtitle=""
              desc="From network management and system monitoring to helpdesk support and software updates, we ensure the smooth functioning of your IT systems, allowing you to focus on your core business operations."
          />
        </div>
        </section>
        {
          managedItSolution.map((item) => (
            <section className={even.includes(item.id) ? evenClass : classes} key={item.id}>
        <div className="flex items-center">
          <TitleBox 
            title={item.title}
            desc={item.description}
          />
          </div>
            <div className="flex lg:w-[500px] w-full lg:h-[300px] h-[250px] relative">
                <img src={item.image} alt="Feature" className="h-full object-cover" /> 
            </div>
      </section>
          ))
        }
    </main>
    <BackToTop />
    <Footer />
    </>
  )
}

export default ManagedSolution